import { Card, Button, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useCallback } from 'react';
import { PRE_WORK_CONTEXT } from '../../shared/Routes';
import {
	Batch,
	PreworkCompletionStatusType,
} from '../../shared/VolunteerApplicationServiceTypes';
import { PreworkCompletionStatus } from '../../shared/Constants';
import { useApplicationId } from '../../hooks/useApplicationId';
import ConfirmTick from '../../assets/images/confirm-tick.svg';
import Icon from '../../components/ui-components/Icon';

export const ApplicationApprovedCard = ({
	pastApplicationId,
	preworkCompletionStatus,
	currentBatch,
}: {
	pastApplicationId?: number;
	preworkCompletionStatus?: PreworkCompletionStatusType;
	currentBatch?: Batch;
}) => {
	const { t } = useTranslation();
	const { mySrcmProfile } = useAuth();
	const { navigateWithApplicationId } = useApplicationId();
	const candidateName = mySrcmProfile?.name;
	const showProceedToPreWorkButton =
		preworkCompletionStatus !== PreworkCompletionStatus.COMPLETED;
	const batchName = currentBatch?.name;

	const handleClickToProceedClick = useCallback(() => {
		navigateWithApplicationId(PRE_WORK_CONTEXT, pastApplicationId);
	}, [navigateWithApplicationId, pastApplicationId]);

	return (
		<>
			<Card className="w-full md:w-[50%] mx-auto px-6 font-sans">
				<div className="flex flex-col items-center text-center space-y-4">
					<div className="text-primary-green font-semibold text-lg">
						{t('approvedIn', { batchName })}
					</div>
					<Divider />
					<Icon src={ConfirmTick} className="!w-24 !h-24" />
					<div className="space-y-2">
						<p>{t('dearCandidateName', { candidateName })}</p>
						<p>{t('thankYouForYourApplication')}</p>
						<p>{t('yourApplicationHasBeenApproved', { batchName })}</p>
						<p>
							{t('heartfulRespectsAndRegards')}
							<br />
							{t('pcmsTeam')}
						</p>
					</div>
				</div>
				<div className="flex justify-center mt-6 font-sans">
					{showProceedToPreWorkButton ? (
						<Button type="primary" onClick={handleClickToProceedClick}>
							{t('clickToProceed')}
						</Button>
					) : (
						<p className="font-bold">{t('preworkCompleted')}</p>
					)}
				</div>
			</Card>
		</>
	);
};
